import { __assign } from "tslib";
import { applyMiddleware } from 'redux';
import { createStore } from 'redux-dynamic-modules-core';
import { getSagaExtension } from 'redux-dynamic-modules-saga';
import { composeWithDevTools } from 'redux-devtools-extension';
import ddt from '@wix/da-ddt';
export function rootModuleStoreFactory(middlewares, logger, initialState, rootReducer, rootSaga, useOld) {
    if (useOld === void 0) { useOld = true; }
    // @ts-ignore
    var sagaExt = getSagaExtension(undefined, function (error, stack) {
        logger.error('Uncaught error in saga', error, stack);
        ddt.alert('redux', "Saga crashed: ".concat((error && error.message) || 'unknown'), ['fatal'], {
            stacktrace: error && error.stack,
            sagastack: stack,
        });
    });
    var store = createStore({
        initialState: initialState,
        extensions: [sagaExt],
        enhancers: [applyMiddleware.apply(void 0, middlewares)],
        advancedComposeEnhancers: composeWithDevTools({}),
    }, getRootModule(rootReducer, rootSaga));
    return store;
}
function getRootModule(rootReducer, rootSaga) {
    return {
        id: 'rootModule',
        reducerMap: __assign({}, rootReducer),
        sagas: [rootSaga],
        retained: true,
    };
}
//# sourceMappingURL=factory.js.map